import React, {useState, useEffect} from "react";
import {useParams, Switch, Route} from "react-router-dom";
import { getPlan } from "../../../apis/options/PlanApi";
import PlanSummary from "./summary/PlanSummary";
import { Row, Col } from "react-bootstrap";
import PlanDetails from "./details/PlanDetails";
import AddPlanForm from "./details/addPlan/AddPlanForm";
import EditPlanForm from "./details/editPlan/EditPlanForm";
import AddIssueGroupForm from "./details/addIssueGroup/AddIssueGroupForm";
import EditIssueGroupForm from "./details/addIssueGroup/EditIssueGroupForm";
import AddEmpOptionForm from "../Option/AddEmpOptionForm";

/* handle all the path combos to get to the pages we want to load */

const PlanPage = _ => {

    const { pathplanarg1, pathplanarg2 } = useParams();

    const [plan, setPlan] = useState(null);
    const [planLoading, setPlanLoading] = useState(true);

    useEffect(() => {
        async function loadPathNavigation() {
            
            setPlanLoading(true);

            //handle if the path param is:
            //  - not present, default to current plan (plans)        
            //  - "summary" (plans/summary), or
            //  - a plan id (plans/10)k

            if(pathplanarg1 || (!isNaN(pathplanarg2)))
            {
                await loadPlan(pathplanarg1);
            }

            setPlanLoading(false);            
        }
        
        async function loadPlan(pid) {
            try {
                const p = await getPlan(pid);
                
                setPlan(p);
            } catch {
                setPlan(null);
            }
        }

        loadPathNavigation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathplanarg1, pathplanarg2]);

    return (
        <>
            
            { !planLoading ? 
                <Row>
                    <Col></Col>
                </Row>
            : <Row>Loading navigation... </Row>}
            <Row>
                <Col id="page-switch">
                    <Switch>
                        <Route exact path="/options/plans/summary" component={PlanSummary} />
                        <Route exact path="/options/plans/add" component={AddPlanForm} />
                        <Route exact path="/options/plans/:planId/edit" component={EditPlanForm} />
                        <Route exact path="/options/plans/:planid" component={PlanDetails} />
                        <Route exact path="/options/plans/:planId/groups/add" component={AddIssueGroupForm} />
                        <Route exact path="/options/plans/:planId/groups/:groupId/edit" component={EditIssueGroupForm} />
                        <Route exact path="/options/plans/:planId/groups/:groupId/options/add" component={AddEmpOptionForm} />
                    </Switch>                
                </Col>
            </Row>
        </>

    );

}

export default PlanPage;